import axios from 'axios';

export default class LoadDataService {
  public saveLoadedData(userId: string, account: any): Promise<any> {
    return axios.put('api/account/loaded/' + userId, account);
  }
}
